export const languageOptions = ['nl', 'fr', 'en', 'de'] as const;
export type LanguageKey = typeof languageOptions[number];

export interface I18n {
  default: LanguageKey;
  translations: Translations;
}

export type Translations = Partial<Record<LanguageKey, any>>;
